export const formDefaultValues = {
  reason: '',
  observations: '',
  attached: [],
  shared: [],
  clinicHistoryFields: [{ value: '' }],
  visit: '',
  shareWithAll: false,
}
